document.addEventListener("DOMContentLoaded", function() {
  /* Add To Cart Product on Variant Select */
  document.body.addEventListener("click", function(event) {
    if(event.target.classList.contains("variant-sizes")) {
      var value = event.target.getAttribute("value");
      var variantOptions = event.target.closest(".variant-options");
      var idInput = variantOptions.querySelector('[name="id"]');
      var buyButton = variantOptions.querySelector(".buy-buttons button");

      if(idInput) {
        idInput.value = value;
      }

      if(buyButton) {
        buyButton.click();
      }
    }
  });

  /* Collection Page Product Design */
  var producLlist = document.querySelector(".product-list");  
  var productCard = producLlist.querySelectorAll(".product-card");
  
  productCard.forEach(function(element, index) {
    if((index + 1) % 20 === 9 || (index + 1) % 20 === 10) {
      element.classList.add("cstm-prd1");
    }
      
    if((index + 1) % 20 === 19 || (index + 1) % 20 === 0) {
      element.classList.add("cstm-prd2");
    }
  });
});
